import React, { useState, useEffect } from 'react';
import logo from '../../space.webp';
import Cookies from 'universal-cookie';
import './personInfo.css';
import loading from '../../img/loading.gif';
import print from '../../img/print.png'
import edit from '../../img/edit.png'
import trash from '../../img/trash.png'
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { Buffer } from 'buffer'
import { createPerson, createTraitor, createPersonCollapsed, createTraitorCollapsed, 
    createAddressCollapsed, createAutoCollapsed, createCompanyCollapsed, createContactCollapsed, 
    createGunCollapsed, createDocCollapsed, createArchCollapsed, createOPMCollapsed, createBSCollapsed, createKanCollapsed, 
    createDoc,
    createGun,
    showError} from '../ViewCreator';


const cookies = new Cookies();
function GunInfo() {

    const [type, setType] = useState(0);

    const mainSubmit = () => {
        window.location.href = "/main";
    };


    useEffect(() => {
        if (cookies.get('type') != null) {
            var t = cookies.get('type')
            setType(t);
        }


        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get("id");
        sendDoc(id);
    }, []);

    const setViews = (inner) => {
        var a = document.getElementById("viewFull");
        a.innerHTML = ""
        for (let index = 0; index < inner.length; index++) {
            a.appendChild(inner[index])
        }
    }

    const sendDoc = (id) => {
        var path = ip + '/api/gun/info';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    Swal.fire({
                        title: result.msg,
                        icon: "error",
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                    })

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);


                    var zz = []

                    var pers = result.data
                    var pe = createGun(pers)
                    zz.push(pe)

                    

                    if(pers.persons != undefined){
                        var adr = document.createElement('div');
                        adr.innerHTML = "<br><hr>Особи:";
                        zz.push(adr)
                        
                            var a = createPersonCollapsed(pers.persons, 0, 0, undefined);
                           
                            const dblcl = i => () => {
                                sendPersonFullScreen(i)
                            }
                            a.ondblclick = dblcl(pers.persons.id)
                            zz.push(a)

                        
                    }

                    

                   
                    setViews(zz)

                    if(pers.persons != undefined){
                            if (pers.persons.image != undefined) {
                                getAvatar(pers.persons.image, 'prevImageSearch')
                            }
                       
                    }

                }
            })
    }

    const sendPersonFullScreen = (id) => {
        window.open("/person?id=" + id)
    }

    const getAvatar = async (id) => {
        var path = ip + '/files/avatar';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    Swal.fire({
                        title: result.msg,
                        icon: "error",
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: 'ОК',
                        denyButtonText: 'Оновити',
                        background: '#2B2B2B',
                        color: '#FFF'
                    }).then((result) => {
                    })

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);


                    var a = document.getElementById('image' + id)
                    a.src = 'data:image/png;base64,' + result.data
                    a.className = 'prevImageSearch'
                }
            })

    }


    const printSubmit = () => {

    }

   const editSubmit = () => {
           const queryParams = new URLSearchParams(window.location.search)
           const id = queryParams.get("id");
           window.open("/edit/gun?id="+id, "_self")
       }
   
       const trashSubmit = () => {
           Swal.fire({
               title: 'Ви дійсно бажаєте видалити запис',
               //text: "Оновити інформацію?",
               icon: 'question',
               html:
                   '',
               showDenyButton: false,
               showCancelButton: true,
               confirmButtonText: 'Видалити',
               denyButtonText: 'Оновити',
   
               background: '#2B2B2B',
               color: '#FFF'
           }).then((result) => {
               if (result.isConfirmed) {
                   removePerson()
               }
           })
       }
   
       const removePerson = () => {
           const queryParams = new URLSearchParams(window.location.search)
           const id = queryParams.get("id");
           var path = ip + '/api/gun/remove';
           var bd = encryptAes((id))
           const requestOptions = {
             headers: {
               'Content-Type': 'Content-type: text/html'
             },
             credentials: 'include',
             uri: path,
             encoding: 'latin1',
             body: bd,
             method: 'POST'
           };
           fetch(path, requestOptions)
             .then()
             .then(response => { return response.arrayBuffer() })
             .then((buffer) => {
               const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
               const text = decoder.decode(buffer);
               try {
                 var result = JSON.parse(text);
                 showError(result.msg)
       
               } catch (error) {
                 const decryptedText = decryptAes(text);
                 var result = JSON.parse(decryptedText);
                 storeKey('test_data', result.key);
                 Swal.fire({title: 'Видалено', text: '', icon: 'success', timer: 5000 ,background: '#2B2B2B',
                   color: '#FFF',
                   didClose: (toast) => {
                     window.open("/main","_self")
                   }})
                 
               }
             })
         }

    return (
        <div className="main">
            <div className="header">
                <img src={logo} className="logo" alt="logo" />
                <div className="title" onClick={mainSubmit}>SPACE</div>
                <div className="subtitle">(info) </div>

                <button className="headerButton" onClick={printSubmit} >
                    <img src={print} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 2} onClick={editSubmit} >
                    <img src={edit} className="headerImage" />
                </button>
                <button className="headerButton" hidden={type > 1} onClick={trashSubmit} >
                    <img src={trash} className="headerImage" />
                </button>

            </div>


            <div id="viewFull">

            </div>
        </div>
    );
}


export default GunInfo;